type BaseSkeletonProps = {
  height?: string;
  width?: string;
  className?: string;
};

const BaseSkeleton = ({ height, width }: BaseSkeletonProps) => {
  return (
    <span
      className="base-skeleton skeleton-loader animation--wave"
      style={{ height: height, width: width }}
    >
      <span className="skeleton">‌</span>
    </span>
  );
};

export default BaseSkeleton;
